import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'lb',
    fullName: 'Luxembourgish',
    nativeName: 'Lëtzebuergesch',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Eppes Erstaunlech kënnt",
    landing_subtitle: "ArgVoid ass en App- a Spillentwécklungsstudio. Bleift drun, nei Saache kommen geschwënn!",
    select_language: "Wielt Sprooch",
    search_placeholder: "Sproochen sichen...",
    terms_title: "Konditioune vum Service",
    policy_title: "Privatsphär Politik",
    cookies_title: "Cookie Politik",
    terms_content: `
        <strong>1. Akzeptanz vun de Konditioune</strong><br>
        Duerch Zougang zu ArgVoid ginn dës Servicebedéngungen ugeholl. Wann dës Konditioune net ausgemaach ginn, soll de Service net benotzt ginn.<br><br>

        <strong>2. Plattform Benotzung</strong><br>
        ArgVoid a seng Uwendungen ginn "wéi ass" fir Informatioun a kreativ Zwecker geliwwert. De Service muss nëmme fir gesetzlech Zwecker benotzt ginn.<br><br>

        <strong>3. Verbueden Conduct</strong><br>
        Ausnotzen vu Schwachstelle vu Site, Spam oder Versuch vun onerlaabten Zougang zu der Infrastruktur ass strikt verbueden.<br><br>

        <strong>4. Verzichterklärung</strong><br>
        D'Plattform a Servicer kënnen zu all Moment ouni Préavis geännert ginn. Keng Garantie gëtt iwwer d'Uptime oder Disponibilitéit vum Service geliwwert.
    `,
    policy_content: `
        <strong>1. Informatiounen Collection</strong><br>
        D'Plattform erfuerdert keng Benotzerauthentifizéierung oder Kontkreatioun zu dësem Zäitpunkt. Keng perséinlech Identifikatiounsinformatioun (wéi Nimm oder E-Mailadressen) gëtt aktiv vu Besucher gesammelt.<br><br>

        <strong>2. Benotzen Data</strong><br>
        Basis, anonymiséiert Analyse kënne gesammelt ginn fir de Siteverkéier ze verstoen an d'Applikatiounen ze verbesseren. Dës Donnéeë sinn net mat eenzelne Benotzer Identitéiten verbonnen.<br><br>

        <strong>3. Drëtt Partei Services</strong><br>
        Drëtt Partei Ubidder kënne fir Hosting an Analyse Servicer benotzt ginn. D'Privatsphärpraktiken vun dëse jeeweilege Fournisseuren regéieren déi anonym Donnéeën, déi op hirer Infrastruktur veraarbecht ginn.<br><br>

        <strong>4. Daten Sécherheet</strong><br>
        Raisonnabel Sécherheetsmoossname ginn ëmgesat fir d'Plattform ze schützen. Wéi och ëmmer, keng Method fir Iwwerdroung iwwer Internet ass ganz sécher.<br><br>
    `,
    cookies_content: `
        <strong>1. Wat sinn Cookien a Lokal Lagerung? </strong><br>
        Cookien a Browser lokal Späichere si kleng Datedateien, déi um Apparat gespäichert sinn, fir d'Konfiguratiounsvirléiften iwwer Visiten ze erënneren.<br><br>

        <strong>2. Benotzen Zweck</strong><br>
        Browser LocalStorage gëtt strikt benotzt fir Konfiguratiounsastellungen ze späicheren, sou wéi: <br>
        - Sprooch Virléiften<br>
        - User Interface Konfiguratioun (zB Layout oder Thema Astellunge) <br>
        - Temporär Applikatioun Cache<br><br>

        <strong>3. Keng Tracking</strong><br>
        Cookien a lokal Späichere ginn net fir Reklammen oder Drëtt Partei Tracking Zwecker benotzt. All gespäichert Daten sinn strikt fir d'Kärfunktioun vun der Plattform.<br><br>

        <strong>4. Spezifikatioune vun </strong><br>
        Browserdaten kënnen zu all Moment duerch d'Browser-Astellunge geläscht ginn, déi all lokal Konfiguratiounen zrécksetzen.
    `,
    cookie_consent_text: "Mir benotze Basis Cookien fir sécherzestellen datt d'Websäit richteg funktionnéiert, sou wéi Är Sessioun aktiv ze halen, Är Sproochevirléiften ze späicheren an aner personaliséiert Konfiguratiounen.",
    read_policy: "Liesen Cookie Politik",
    support_title: "Kontakt Support",
    support_subject_label: "Sujet",
    support_message_label: "Message",
    support_submit_button: "Schécken Message",
    support_hint: "Notiz: Dëst wäert Är Standard E-Mail-Applikatioun opmaachen fir de Message ze schécken.",
    support_success_msg: "Öffnen Är E-Mail App ...",
    support_error_msg: "Ausgefall Message ze schécken. Probéiert w.e.g. méi spéit nach eng Kéier.",
    explorer_title: "Explorer",
    history_title: "Geschicht",
    animation_title: "Animatioun",
    config_title: "Configuratioun",
    tool_mouse: "Wielt (Ctrl+M)",
    tool_brush: "Pinsel (Ctrl+B)",
    tool_brush_mode: "Toggle Modus (solid / kloer)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Ajustéieren Pinsel Gréisst",
    tool_bucket: "Fëllt (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Gitter (Ctrl+Shift+B)",
    tool_rotate: "Rotéieren (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Breet",
    label_height: "Héicht",
    label_frames: "Zuel vu Frames",
    label_animation: "Animatioun Stil",
    label_background_color: "Hannergrond Faarf",
    label_interval: "Intervall",
    tool_anim_config: "Animatioun Configuratioun",
    label_new_width: "Nei Breet",
    label_new_height: "Nei Héicht",
    label_apply: "Bewerbung",
    label_colors: "Faarwen",
    label_size: "Gréisst",
    label_tolerance: "Toleranz",
    val_horizontal: "Horizontal",
    val_vertical: "Vertikal",
    val_sequence: "Sequenz",
    val_bounce: "Boun",
    val_random: "Zoufälleg",
    val_solid: "Solid",
    val_clear: "Kloer",
    action_add_sheet: "Neit Blat",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Zortéieren",
    sort_date_old: "Déi eelst Éischt",
    sort_date_new: "Neisten Éischt",
    sort_name_az: "Numm (A-Z)",
    sort_name_za: "Numm (Z-A)",
    action_new_sprite: "Neie Sprite",
    action_new_project: "Neie Projet",
    modal_save_all_title: "All Ännerungen späicheren",
    modal_save_all_desc: "Wielt d'Verméigen fir ze späicheren:",
    modal_save_selected: "Späicheren ausgewielt",
    action_saved: "Gespäichert",
    modal_create_sprite_title: "Schafen New Sprite",
    modal_create_project_title: "Neie Projet erstellen",
    modal_add_sheet_title: "Neie Blat derbäi",
    modal_rename_sheet_title: "Blatt ëmbenennen",
    modal_rename_sprite_title: "Umbenannt Sprite",
    modal_delete_sprite_title: "Läschen Sprite",
    modal_delete_project_title: "Läschen Projet",
    modal_delete_sheet_title: "Blat läschen",
    placeholder_sprite_name: "Numm",
    placeholder_project_name: "Numm",
    placeholder_sheet_name: "Numm",
    placeholder_new_name: "Neien Numm",
    action_create: "Schafen",
    action_add: "Addéieren",
    action_rename: "ëmbenennen",
    action_duplicate: "Duplizéiert",
    action_delete: "Läschen",
    action_cancel: "Ofbriechen",
    confirm_delete_sprite: "Sidd Dir sécher datt Dir dëse Sprite läschen wëllt?",
    confirm_delete_project: "Sidd Dir sécher datt Dir dëse Projet läsche wëllt? All Sprite ginn ewechgeholl.",
    confirm_delete_sheet: "Sidd Dir sécher, datt Dir dëse Blat läschen wëllt?",
    err_select_sprite: "Wielt w.e.g. e Sprite fir d'éischt.",
    err_select_project: "Wielt w.e.g. e Projet fir d'éischt.",
    err_name_empty: "Numm kann net eidel ginn.",
    err_sprite_exists: "E Sprite mat deem Numm gëtt et schonn.",
    err_project_exists: "E Projet mat deem Numm gëtt et schonn.",
    err_no_content: "Keen Inhalt fir ze späicheren.",
    err_no_changes: "Keng Ännerungen ze späicheren.",
    err_delete_last_sheet: "Kann de leschte Blat net läschen.",
    err_extract_frames: "Konnt keng Rummen extrahéieren.",
    err_indexeddb: "Ausgefall lokal ze späicheren. Äre Browser kann IndexedDB net ënnerstëtzen.",
    msg_upload_success: "Eroplueden erfollegräich: {0}",
    msg_upload_failed: "Eroplueden ausgefall: {0}",
    msg_save_success: "Retten erfollegräich.",
    msg_saving: "Spuert ...",
    msg_multi_save_result: "{0} Verméigen gespäichert. {1} Feeler.",
    menu_title: "Menu",
    menu_save: "Spueren",
    menu_save_all: "Alles späicheren",
    menu_support: "Kontakt Support",
    label_local_storage: "Lokal Lagerung",
    label_sign_in: "Umellen",
    modal_export_title: "Export Sprite",
    label_filename: "Dateinumm",
    label_format: "Format",
    action_export_confirm: "Export",
};

export default translations;
